import {
  Content,
  ContentHeader,
  HeaderLabel,
  SupportButton,
  WarningPanel,
} from '@backstage/core-components';
import { useApi } from '@backstage/core-plugin-api';
import { Header } from '@internal/plugin-components-react';
import { Typography } from '@material-ui/core';
import React from 'react';
import UserAccessTable from './UserAccessTable';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import useAsyncRetry from 'react-use/lib/useAsyncRetry';
import { useParams } from 'react-router-dom';
import { isUserEntity, } from '@backstage/catalog-model';
export function UserAccessPage() {
  const { userId } = useParams();
  const catalogApi = useApi(catalogApiRef);
  const { value: entity, error: getEntityError } = useAsyncRetry(
    () =>
      catalogApi.getEntityByRef({
        kind: 'user',
        namespace: 'default',
        name: userId,
      }),
    [catalogApi],
  );
  const renderHeader = (entity) => {
    // Render user entity only
    if (!entity || !isUserEntity(entity)) return;
    const displayName =
      entity.spec.profile?.displayName || entity.metadata.name;
    const email = entity.spec.profile?.email;
    const group = entity.spec.memberOf?.[0];
    return (
      React.createElement(Header, {
        title: displayName,
        breadcrumbItems: [
          { text: 'Access Control', href: '/access-control' },
          { text: displayName },
        ],}
      
        , email && React.createElement(HeaderLabel, { label: email, value: "Email",} )
        , group && React.createElement(HeaderLabel, { label: group, value: "Team",} )
      )
    );
  };
  return (
    React.createElement(React.Fragment, null
      , getEntityError && (
        React.createElement(WarningPanel, {
          severity: "error",
          title: "Fetching entity error"  ,
          message: "Oops! An error occurred while fetching entity, please reach out to our support team for help."               ,}
        )
      )
      , renderHeader(entity)
      , React.createElement(Content, null
        , React.createElement(ContentHeader, {
          titleComponent: React.createElement(Typography, { variant: "h5",}, "Access"),}
        
          , React.createElement(SupportButton, null, "All of user access"   )
        )
        , React.createElement(UserAccessTable, null )
      )
    )
  );
}
